module.exports = __webpack_public_path__ + "static/img/T7404.08be7e18.png";